import React from 'react'
import UserCard from '../components/Dashboard/UserCard'
import '../components/Dashboard/dashboard.css'
// import MatchesCard from '../components/Dashboard/MatchesCard'
import ActivitySummary from '../components/Dashboard/ActivitySummary'
import Notifications from '../components/Dashboard/Notifications'
import {useSelector } from 'react-redux'
import ProfileUpdated from '../components/Dashboard/ProfileUpdated'
// import Slider from '../components/Dashboard/Slider'


function Dashboard() {
    const { user } = useSelector((state) => state.user);
    return (
        <div className="container dashboard" style={{marginBottom:125}}>
            <div className='row'>
                <div className='col-lg-3 col-md-6 col-sm-12'>
                    <UserCard user={user} />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                    <ActivitySummary />
                    <div className='mt-3'>
                        <ProfileUpdated />
                    </div>
                </div>
                <div className='col-lg-3 col-md-6 col-sm-12'>
                    <Notifications />
                </div>
                {/* <div className="col-lg-12 col-md-12 col-sm-12 ">
                        <Slider />
                </div> */}
                {/* <div className="col-lg-4 col-md-6 col-sm-12">
                    <MatchesCard title={"New Matches for you"} />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <MatchesCard title={"Premium Matches"} />
                </div> */}
            </div>
        </div >
    )
}

export default Dashboard